// 旧版会员类型
export const vipCodeTypeMap = {
    0: '尊享会员',
    1: 'V卡会员',
    3: '至尊会员',
    6: '体验版会员',
    7: '启航会员',
    8: '精英会员',
    71: '青春版会员',
    81: '卓越版会员'
};

// 新版会员类型
// 启航 -> 青春
// 精英 -> 卓越
export const newVipCodeTypeMap = {
    0: '尊享会员',
    1: 'V卡会员',
    3: '至尊会员',
    6: '体验版会员',
    7: '青春版会员',
    8: '卓越版会员',
    71: '青春版会员',
    81: '卓越版会员'
};